import { lodash } from 'helpers';
import { formatDecimalValue } from 'libs/form/fields/DecimalField/helpers';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { DirectoryAutocompleteField } from 'modules/account/common/features';
import { MAX_FLOATING_POINTS } from 'modules/account/orderModule/common/constants';

import { Field, useFormContext } from '../../../forms/orderForm';
import { OrderSection } from '../../OrderSection';

import { useTransactionVolumeSection } from './useTransactionVolumeSection';

export const TransactionVolumeSection = () => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const {
    isDisabledUnitPrice,
    isTransactionAmountDisabled,
    currencies,
    nominalQuantity,
  } = useTransactionVolumeSection();

  return (
    <OrderSection
      fields={lodash.compact([
        <Field.Quantity
          fullWidth
          showRequiredMark
          label={t(
            'account.order.sections.transactionVolumeSection.fields.quantity.label'
          )}
          minNumber={1}
          name="transactionVolume.quantity"
          placeholder={t(
            'account.order.sections.transactionVolumeSection.fields.quantity.placeholder'
          )}
        />,
        <Input
          fullWidth
          readOnly
          disabled={!readOnly}
          label={t(
            'account.order.sections.transactionVolumeSection.fields.nominalQuantity.label'
          )}
          name="transactionVolume.nominalQuantity"
          value={formatDecimalValue(nominalQuantity, MAX_FLOATING_POINTS, 0)}
        />,
        <Field.Decimal
          fullWidth
          disabled={readOnly ? false : isDisabledUnitPrice}
          label={t(
            'account.order.sections.transactionVolumeSection.fields.unitPrice.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          name="transactionVolume.unitPrice"
          placeholder={
            isDisabledUnitPrice
              ? undefined
              : t(
                  'account.order.sections.transactionVolumeSection.fields.unitPrice.placeholder'
                )
          }
          showRequiredMark={!isDisabledUnitPrice}
        />,

        <DirectoryAutocompleteField<{ value: string; label: string }, false>
          fullWidth
          showRequiredMark
          directorySchemaName={currencies.currency.directorySchemaName}
          fieldName={currencies.currency.fieldName}
          label={t(
            'account.order.sections.transactionVolumeSection.fields.currency.label'
          )}
          name="transactionVolume.currency"
          placeholder={t(
            'account.order.sections.transactionVolumeSection.fields.currency.placeholder'
          )}
        />,

        <Field.Decimal
          fullWidth
          disabled={readOnly ? false : isTransactionAmountDisabled}
          label={t(
            'account.order.sections.transactionVolumeSection.fields.transactionAmount.label'
          )}
          maxFloatingPoints={MAX_FLOATING_POINTS}
          maxIntegerLength={0}
          name="transactionVolume.transactionAmount"
          placeholder={
            !isDisabledUnitPrice
              ? t(
                  'account.order.sections.transactionVolumeSection.fields.transactionAmount.placeholder'
                )
              : undefined
          }
          showRequiredMark={!isDisabledUnitPrice}
        />,
      ])}
      title={t('account.order.sections.transactionVolumeSection.title')}
    />
  );
};
